import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { selectToast } from '@core/store/modal.selectors';
import { hideToast } from '@core/store/modal.actions';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

@Component({
  selector: 'app-toast',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './toast.html',
  styleUrl: './toast.css',
  standalone: true,
})
export class Toast implements OnDestroy {
  readonly toast$;

  private timer: ReturnType<typeof setTimeout> | null = null;
  private readonly sub: Subscription;

  constructor(private readonly store: Store) {
    this.toast$ = this.store.select(selectToast);

    this.sub = this.toast$.subscribe((toast) => {
      if (!toast.isOpen) return;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.store.dispatch(hideToast());
      }, 3000);
    });
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.sub.unsubscribe();
  }

  closeToast(): void {
    this.store.dispatch(hideToast());
  }
}
